<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="left" @click="goback()">< 返回</div>
        <div class="span1">
          <span>{{ info.className }} 开班情况</span>
        </div>
      </div>
      <div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="studentName" label="授课老师" align="center">
            </el-table-column>
            <el-table-column prop="className" label="课时总数" align="center">
            </el-table-column>
            <el-table-column prop="signTime" label="招生年级" align="center">
            </el-table-column>
            <el-table-column prop="q" label="授课学校" align="center">
            </el-table-column>
            <el-table-column prop="w" label="上课地点" align="center">
            </el-table-column>
            <el-table-column prop="e" label="招生数" align="center">
            </el-table-column>
            <el-table-column prop="r" label="报名数" align="center">
            </el-table-column>
            <el-table-column prop="t" label="报名率" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./secondDetail.vue"),
  },
   props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      queryParams: {
        value1: "",
        value2: "",
      },
      sourceList: [],
      semesterList: [],
      teacherList: [],
      tableData: [
        // {
        //   studentName: "谢文华",
        //   className: "30",
        //   signTime: "三年级",
        //   q: "驻马店实验小学",
        //   w: "二年级3班",
        //   e: "50",
        //   r: "42",
        //   t: "84.00%",
        // },
        // {
        //   studentName: "单楚苏",
        //   className: "30",
        //   signTime: "四年级",
        //   q: "驻马店市第一小学",
        //   w: "三年级7班",
        //   e: "50",
        //   r: "40",
        //   t: "80.00%",
        // },
        // {
        //   studentName: "陈正清",
        //   className: "50",
        //   signTime: "三年级",
        //   q: "驻马店市驿城区小学 ",
        //   w: "一年级5班",
        //   e: "50",
        //   r: "45",
        //   t: "90.00%",
        // },
        // {
        //   studentName: "朱政廷",
        //   className: "50",
        //   signTime: "五年级",
        //   q: "驻马店市第七小学",
        //   w: "二年级4班",
        //   e: "50",
        //   r: "44",
        //   t: "88.00%",
        // },
        // {
        //   studentName: "邓诗涵",
        //   className: "50",
        //   signTime: "一年级",
        //   q: "驻马店市第二小学",
        //   w: "三年级2班",
        //   e: "50",
        //   r: "44",
        //   t: "88.00%",
        // },
        // {
        //   studentName: "李必先",
        //   className: "50",
        //   signTime: "三年级",
        //   q: "驻马店市第十小学",
        //   w: "三年级6班",
        //   e: "50",
        //   r: "46",
        //   t: "92.00%",
        // },
        // {
        //   studentName: "陈正清",
        //   className: "30",
        //   signTime: "六年级",
        //   q: "驻马店市第九小学",
        //   w: "一年级6班",
        //   e: "50",
        //   r: "42",
        //   t: "84.00%",
        // },
        // {
        //   studentName: "吴博俊",
        //   className: "50",
        //   signTime: "五年级",
        //   q: "驻马店市第三小学",
        //   w: "三年级1班",
        //   e: "50",
        //   r: "43",
        //   t: "86.00%",
        // },
        // {
        //   studentName: "邓诗涵",
        //   className: "50",
        //   signTime: "三年级",
        //   q: "驻马店市回族小学",
        //   w: "一年级1班",
        //   e: "50",
        //   r: "45",
        //   t: "90.00%",
        // },
        // {
        //   studentName: "陈政倩",
        //   className: "30",
        //   signTime: "二年级",
        //   q: "驻马店市第六小学",
        //   w: "三年级7班",
        //   e: "50",
        //   r: "44",
        //   t: "88.00%",
        // },
      ],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
    };
  },
  watch: {
    "type.source": function (n, o) {
    },
  },
  mounted() {
    // this.semesterList = this.semesterArr.map((v) => ({
    //   label: v.schoolYear + "第" + v.semester + "学期",
    //   id: v.schoolYear + "_" + v.semester,
    // }));
    this.getDataList();
  },
  created() {},
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        campusId: this.queryParams.campus,
        gradeId: this.queryParams.grade,
        classId: this.queryParams.class,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
      };
      this.tableData = [];
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
	goback(){
       this.$emit("to-index");
	},
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
		margin-left: 35%;
      font-family: "PingFang SC Bold";
      font-size: 20px;
      text-align: left;
      color: #000;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
